import React from "react";
import { useTranslation } from "react-i18next";
import { useInstantSearch, useStats } from "react-instantsearch-core";

import algoliaFiltersFromUiState from "../../../../algolia/utils/algoliaFiltersFromUiState";
import DropdownMenu from "../../../../ui/components/DropdownMenu/DropdownMenu";

import productionsExportCsv from "../../../api/productionsExportCsv";

const EXPORT_CSV_LIMIT = 20000;

export default function ExportCsvDropdown() {
	const { t } = useTranslation();
	const { indexUiState } = useInstantSearch();
	const { nbHits } = useStats();

	return (
		<DropdownMenu
			options={[
				{
					text: t("exportCSV", "Export CSV"),
					action: () => {
						if (nbHits > EXPORT_CSV_LIMIT) {
							throw new Error(
								t(
									"exportCsvTooManyHits",
									"Cannot export more than {{limit}} productions. Please refine your filters.",
									{ limit: EXPORT_CSV_LIMIT.toLocaleString() },
								),
							);
						}

						const { query, filters, sortBy } = algoliaFiltersFromUiState(indexUiState);

						return productionsExportCsv({ query, filters, sortBy });
					},
				},
			]}
		/>
	);
}
